
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Clientes from '@lib/Clientes'
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: Clientes.Personas } )
        public value: Clientes.Personas;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
        }

        constructor() {
            super();
        }

        public items: Array<Clientes.Personas> = Clientes.Personas.Options;

        public selected: Clientes.Personas | null = null;
        public get Selected(): Clientes.Personas | null {
            return this.selected;
        }
        public set Selected( x: Clientes.Personas | null ) {
            console.log(x );
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }
    }
